<template>
  <div class="row">
    <div v-if="notice" class="callout notice">{{notice}}</div>
    <h1 class="page-header text-center">$pringpay</h1>
    <div class="page-sub-header text-center">
      <h5 class="page-sub-header-text">powered by</h5>
      <img class="spence-logo" :src="spenceLogo" alt="spence"/>
    </div>
    <div v-if="isProgramLoading" class="loading-container">
      <sb-loading-icon />
    </div>
    <div v-else class="medium-6 columns small-centered">
      <div class="cash_per_point_enabled-wrapper">
        <label for="merchant_spence_api_key" class="text-center field-label">enter your spence api token</label>
        <input
          type="text"
          data-cy="spence-landing-spence-api-key-input"
          v-model="merchant_spence_api_key"
          :disabled="!canEditSettings"
          name="merchant[spence_api_key]"
          id="merchant_spence_api_key"
          :class="{ error: error }"
          @focus="onFocus()"
          @blur="onBlur()"
        />
        <div v-if="error" class="input-error">
          {{ error }}
        </div>
      </div>
      <div class="sb-row space-evenly bottom-spacing">
        <button @click.stop.prevent="clickedCancel" :disabled="submitting" class="link-delete">cancel</button>
        <button @click="clickedSubmit" :disabled="submitting || !!error" class="action-button button proceed">update</button>
      </div>
      <div class="sb-row center">
        <a href="https://gospence.com/contact-us/">new to spence?</a>
      </div>
    </div>
  </div>
</template>

<script>
  import UserAbilitiesMixin from '../../mixins/UserAbilitiesMixin'
  import { currentMerchantAPI } from "../../services/api/currentMerchant"
  import { mapGetters } from 'vuex'
  import spenceLogo from 'spence/spence_logo.svg';

    export default {
      name: "SpenceLanding",
      data() {
        return {
          merchant_spence_api_key: "",
          merchant_spence_api_key_hidden: "",
          merchant_spence_api_key_original: "",
          spenceLogo: spenceLogo,
          isProgramLoading: false,
          showSpence: false,
          submitting: false,
          notice: "",
          error: "",
        }
      },
      mixins: [UserAbilitiesMixin],
      computed: {
        merchantId() {
          return this.$route.params.id
        },
        canEditSettings() {
          return this.hasAccess(this.userAbilitiesValue, 'SETTINGS_EDIT')
        },
        spenceApiKey() {
          return this.$store.state.currentMerchant.spence_api_key;
        },
        ...mapGetters(
          ['userAbilitiesValue']
        )
      },
      watch: {
        spenceApiKey(newValue) {
          const last4Elements = newValue.slice(-4);
          this.merchant_spence_api_key_original = newValue;
          this.merchant_spence_api_key_hidden = `●●●●●${last4Elements}`;
          this.merchant_spence_api_key = this.merchant_spence_api_key_hidden;
        },
        merchant_spence_api_key(newValue) {
          if (newValue.includes("●")) return;
          if (!newValue) {
            this.merchant_spence_api_key_original = "";
            this.merchant_spence_api_key_hidden = "";
            return;
          }
          const last4Elements = newValue.slice(-4);
          this.merchant_spence_api_key_original = newValue;
          this.merchant_spence_api_key_hidden = `●●●●●${last4Elements}`;
          if (newValue.length < 50) {
            this.error = "Token length must be at least 50";
          }
          else {
            this.error = "";
          }
        }
      },
      async created() {
        this.$store.dispatch('LOAD_CURRENT_USER')
        this.$store.dispatch('LOAD_CURRENT_MERCHANT')
        this.isProgramLoading = true
        try {
          const settings = await currentMerchantAPI.GETCashPerPointsSettings();

          this.showSpence = settings.show_spence
          if (this.showSpence) {
            this.isProgramLoading = false
          } else {
            location.replace(`/merchants/${this.merchantId}/`)
          }

        } catch (error) {
          this.error = "error, please refresh or contact support"
        }
      },
      methods: {
        async clickedSubmit() {
          const body = {
            api_key: this.merchant_spence_api_key_original,
          };

          this.submitting = true;
          try {
            const updateApiKeySuccess = await currentMerchantAPI.PATCHSpenceApiKey(this.merchantId, body)
            this.submitting = false;
            if (updateApiKeySuccess) {
              this.notice = "settings updated"
              this.$router.push(`/merchants/${this.merchantId}/cash_rewards_program`)
            } else {
              this.error = "The api key entered was invalid please check it and try again"
            }
          } catch (error) {
            this.submitting = false;
            this.error = "invalid token";
          }
        },
        clickedCancel() {
          location.replace(`/merchants/${this.merchantId}/`)
        },
        onFocus() {
          this.merchant_spence_api_key = this.merchant_spence_api_key_original;
        },
        onBlur() {
          this.merchant_spence_api_key = this.merchant_spence_api_key_hidden;
        }
      }
    }
</script>
<style scoped>
.page-header {
  color: #128FF9;
  font-weight: 1000;
  font-size: 60px;
  margin-bottom: 0px;
}

.page-sub-header-text {
  margin-bottom: .2rem;
  margin-right: 0.2rem;
}

.page-sub-header {
  text-align: center;
  color: #128FF9;
  font-weight: 1000;
  margin-bottom: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 4rem;
}

.spence-logo {
  height: 1.6rem;
}

.field-label {
  margin-bottom: 1rem;
}

.cash_per_point_enabled-wrapper input.error {
  border: 1px solid red;
}

.input-error {
  text-align: center;
  color: red;
  margin-bottom: 20px;
}
</style>
